import React from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { trackEvent } from "../utils/analytics";

const UserCard = ({ prenom, nom, lien, photo, photoType, userId, teamId }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const isTeamCard = prenom === "Faire dons a toute l'equipe";

  const handleClick = () => {
    localStorage.setItem("lastTipUser", JSON.stringify({ prenom, nom }));
    trackEvent('click_user', 'user', `${prenom} ${nom}`);
    if (teamId) {
      navigate(`/team/${teamId}/pay`);
    } else if (userId) {
      navigate(`/user/${userId}`);
    } else {
      window.open(lien, "_blank", "noopener,noreferrer");
    }
  };

  const displayName = isTeamCard ? nom : prenom;
  const initials = isTeamCard
    ? (nom?.charAt(0) || '?').toUpperCase()
    : ((prenom?.charAt(0) || '') + (nom?.charAt(0) || '')).toUpperCase();

  return (
    <div
      className="bg-white shadow-md border border-gray-100 rounded-2xl p-4 md:p-5 cursor-pointer flex flex-col items-center justify-center w-full max-w-xs aspect-square transition duration-200 hover:shadow-lg hover:scale-[1.03] active:scale-[0.97]"
      onClick={handleClick}
    >
      <div className="flex flex-col items-center justify-center text-center flex-grow w-full gap-3">
        {/* Photo ou initiales */}
        {photo ? (
          <img
            src={photoType === 'url' ? photo : `data:image/jpeg;base64,${photo}`}
            alt={`${prenom} ${nom}`}
            className="rounded-full shadow-sm"
            style={{
              width: "90px",
              height: "90px",
              objectFit: "cover",
            }}
          />
        ) : (
          <div
            className={`rounded-full flex items-center justify-center shadow-sm ${
              isTeamCard ? 'bg-black' : 'bg-gray-200'
            }`}
            style={{ width: "90px", height: "90px" }}
          >
            <span className={`text-2xl font-bold ${isTeamCard ? 'text-white' : 'text-gray-500'}`}>
              {initials}
            </span>
          </div>
        )}

        {/* Nom */}
        <div className="flex flex-col items-center w-full">
          {isTeamCard && (
            <span className="text-gray-400 text-xs font-medium mb-0.5">
              {t("donToAllTeam")}
            </span>
          )}
          <span className="text-sm md:text-base font-bold text-black w-full break-words line-clamp-2 leading-tight">
            {displayName}
          </span>
        </div>
      </div>
    </div>
  );
};

export default UserCard;
